import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class EmployerUser extends ApplicationRecord {
  static jsonapiType = "employer_users";

  @Attr() companyId: number;

  @Attr() fullName: string;

  @Attr() firstName: string;

  @Attr() lastName: string;

  @Attr() password: string;

  @Attr() passwordConfirmation: string;

  @Attr() currentPassword: string;

  @Attr() email: string;

  @Attr() mobileNumber: string;

  @Attr() jobTitle: string;

  @Attr() linkedinUrl: string;

  @Attr() twitterUrl: string;

  @Attr() twitterUsername: string;

  @Attr() biography: string;

  @Attr() avatar: string;

  @Attr() isOwner: boolean;

  @Attr() isAdmin: boolean;

  @Attr() invitationPending: boolean;

  @Attr() photo: {
    data: string;
    filename: string;
  };

  get isRecruiter() {
    return false;
  }

  get isEmployer() {
    return true;
  }

  get role() {
    if (this.isOwner) {
      return "Owner";
    }

    if (this.isAdmin) {
      return "Admin";
    }

    return "Member";
  }
}

export default EmployerUser;
